import React from 'react';
import { Link } from 'react-router-dom';
import { isAuthenticated } from '../services/auth';
import '../styles/EliminacionDatos.css';

const EliminacionDatos = () => {
  const userIsAuthenticated = isAuthenticated();

  return (
    <div className="eliminacion-container">
      <div className="eliminacion-card">
        <div className="eliminacion-header">
          <img 
            src="/sinteligen4.png" 
            alt="KleverBotBase" 
            className="eliminacion-logo"
          />
          <h1>Eliminación de Datos de Usuario</h1>
          <p className="eliminacion-fecha">Última actualización: 10 de septiembre de 2026</p>
        </div>

        <div className="eliminacion-content">
          <section>
            <h2>1. Introducción</h2>
            <p>
              En <strong>KleverBotBase</strong>, operado por <strong>Sinteligen</strong>, respetamos tu derecho a controlar tu información personal. Esta página explica cómo puedes solicitar la eliminación de los datos que hemos recopilado a través de tu uso de nuestra plataforma y de los servicios de WhatsApp Business.
            </p>
          </section>

          <section>
            <h2>2. Datos que Podemos Eliminar</h2>
            <p>Puedes solicitar la eliminación de los siguientes datos:</p>
            <ul>
              <li>Datos de tu cuenta de usuario (nombre, correo electrónico, teléfono).</li>
              <li>Información de tu empresa y configuración del bot.</li>
              <li>Documentos que hayas subido para entrenar el asistente virtual.</li>
              <li>Historial de conversaciones con tus clientes finales.</li>
              <li>Credenciales de conexión con WhatsApp (WABA ID, tokens de acceso).</li>
            </ul>
          </section>

          <section>
            <h2>3. Cómo Solicitar la Eliminación</h2>
            <p>
              Para solicitar la eliminación de tus datos, envía un correo electrónico a <a href="mailto:klever_mix@hotmail.com">klever_mix@hotmail.com</a> con el asunto <strong>"Solicitud de Eliminación de Datos"</strong>. Incluye en el cuerpo del mensaje:
            </p>
            <ul>
              <li>Tu nombre completo.</li>
              <li>El correo electrónico asociado a tu cuenta.</li>
              <li>El nombre de tu empresa en la plataforma.</li>
              <li>Una descripción clara de los datos que deseas eliminar.</li>
            </ul>
          </section>

          <section>
            <h2>4. Plazo de Respuesta</h2>
            <p>
              Procesaremos tu solicitud en un plazo máximo de <strong>30 días hábiles</strong> a partir de la recepción del correo. Te enviaremos una confirmación cuando la eliminación se haya completado. Si necesitamos más información para verificar tu identidad, nos pondremos en contacto contigo.
            </p>
          </section>

          <section>
            <h2>5. Datos que No Podemos Eliminar</h2>
            <p>
              Algunos datos pueden no ser eliminados inmediatamente si estamos obligados a conservarlos por razones legales, regulatorias o de seguridad. En esos casos, te informaremos qué datos se conservan y por qué. Los datos anonimizados o agregados que no te identifican pueden conservarse para análisis estadístico.
            </p>
          </section>

          <section>
            <h2>6. Eliminación Automática</h2>
            <p>
              Si eres un usuario de la plataforma y deseas eliminar tu cuenta y todos los datos asociados de forma permanente, puedes hacerlo directamente desde la configuración de tu cuenta en la plataforma. Ten en cuenta que esta acción es irreversible y eliminará toda tu información, incluyendo conversaciones y documentos.
            </p>
          </section>

          <section>
            <h2>7. Contacto</h2>
            <p>
              Si tienes preguntas sobre este proceso o sobre cómo manejamos tus datos, puedes contactarnos en:
            </p>
            <ul>
              <li><strong>Correo electrónico:</strong> <a href="mailto:klever_mix@hotmail.com">klever_mix@hotmail.com</a></li>
              <li><strong>Plataforma:</strong> <a href="https://crm.sinteligen.com" target="_blank" rel="noopener noreferrer">https://crm.sinteligen.com</a></li>
            </ul>
            <p>
              Para más información sobre cómo tratamos tus datos, consulta nuestra <Link to="/politica-privacidad" className="eliminacion-link">Política de Privacidad</Link>.
            </p>
          </section>
        </div>

        <div className="eliminacion-footer">
          <Link 
            to={userIsAuthenticated ? "/dashboard" : "/login"} 
            className="eliminacion-back-btn"
          >
            {userIsAuthenticated ? "← Volver al Dashboard" : "← Volver al Login"}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default EliminacionDatos;